module.exports = __webpack_public_path__ + "img/jc-gellidon-1386353-unsplash.63b12e36.jpg";